import { render } from "./StartingMenuModal.vue?vue&type=template&id=7d7b736c&scoped=true"
import script from "./StartingMenuModal.vue?vue&type=script&lang=js"
export * from "./StartingMenuModal.vue?vue&type=script&lang=js"

import "./StartingMenuModal.vue?vue&type=style&index=0&id=7d7b736c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d7b736c"]])

export default __exports__